/**
 * seoLandingPagesSlugs.js — Iter 241 bundle-size optimisation.
 *
 * Slim slug-only index used by App.js for route generation.
 * The full content payload (seoLandingPages.js + tier files, ~2.4MB
 * combined) is loaded lazily by `SeoLandingPage` only when a guide
 * URL is actually navigated to.
 *
 * Keep this file in sync with the source-of-truth catalogs in
 * /app/frontend/src/data/seoLandingPages*.js. A static test
 * (test_iter241_seo_slugs.py) verifies parity automatically.
 */

export const SEO_LANDING_PAGE_SLUGS = [
  "military-government-etc-card-reporting",
  "sofa-drivers-etc-toll-records-japan",
  "sofa-driver-etc-record-guide",
  "yokosuka-military-toll-receipts",
  "beigun-yokosuka-etc-record-guide",
  "etc-riyou-shoukai-service-automation",
  "etc-riyoumeisai-guide",
  "etc-riyoushoumeisho-guide",
  "etc-ryoushuusho-guide",
  "etc-riyou-shoukai-service-guide",
  "etc-keihiseisan-guide",
  "houjin-etc-card-management",
  "etc-card-fusei-riyou-check",
  "kousokudouro-ryoushuusho-guide",
  "nexco-etc-meisai-guide",
  "how-to-get-toll-receipts-in-japan",
  "etc-meisai-english-guide",
  "japan-etc-usage-statement-guide",
  "japan-highway-receipts-guide",
  "japan-toll-roads-guide",
  "business-etc-fleet-toll-reporting",
  "corporate-etc-card-management",
  "etc-pdf-csv-download-guide",
  "authorized-vehicle-monitoring",
  "reimbursement-reports",
  "etc-mileage-service-vs-jtr",
  "rental-car-etc-toll-receipts-japan",
  "etc-data-retention-and-report-history",
  "etc-mileage-service-jtr-chigai",
  "rental-car-etc-ryoushuusho-guide",
  "etc-data-hozon-report-rireki-guide",
  "lost-highway-toll-receipt-japan",
  "etc-phishing-and-fake-meisai-emails",
  "etc-onboard-unit-registration-number-guide",
  "kousokudouro-ryoushuusho-funshitsu-guide",
  "etc-meisai-phishing-guide",
  "etc-shasaiki-kanri-bangou-guide",
  "license-plate-last-four-etc-registration",
  "japan-business-trip-toll-receipts",
  "etc-discounts-japan-guide",
  "number-plate-shita4keta-etc-guide",
  "shucchou-etc-ryoushuusho-guide",
  "etc-waribiki-guide",
  "etc-only-toll-gates-japan",
  "how-to-check-nexco-toll-fees",
  "company-car-toll-expense-reports-japan",
  "etc-senyou-ryoukinjo-guide",
  "nexco-ryoukin-kakunin-guide",
  "shayou-sharyou-etc-keihi-guide",
  "etc-card-vs-cash-toll-receipts-japan",
  "japan-toll-gate-lane-types",
  "multiple-etc-cards-one-business-account",
  "vehicle-based-toll-reporting-japan",
  "driver-reimbursement-toll-records-japan",
  "monthly-etc-toll-reporting-for-accounting",
  "etc-card-genkin-ryoushuusho-chigai",
  "kousokudouro-ryoukinjo-lane-guide",
  "fukusu-etc-card-houjin-kanri-guide",
  "sharyou-betsu-etc-report-guide",
  "driver-seisan-etc-record-guide",
  "getsujishori-etc-report-guide",
  "how-to-check-etc-card-usage-online-japan",
  "etc-card-for-foreigners-japan",
  "etc-meisai-login-english-guide",
  "etc-card-types-comparison-japan",
  "rakuten-etc-card-usage-receipts-japan",
  "etc-senyou-gate-conversion-japan",
  "invoice-system-etc-meisai-japan",
  "okinawa-expressway-etc-toll-guide",
  "tokyo-bay-aqualine-etc-discount-guide",
  "etc-shinya-warikibi-guide-japan",
  "shutoko-distance-based-tolls-guide",
  "etc-mileage-weekday-discount-guide",
  "etc-2-keiro-jouhou-service-guide",
  "shin-tomei-120kmh-section-guide",
  "hokkaido-douou-expressway-etc-guide",
  "etc-meisai-pdf-download-howto",
  "etc-meisai-csv-export-howto",
  "etc-meisai-missing-trips-reasons",
  "etc-kyujitsu-warikibi-exclusion-days",
  "etc-senyou-mis-entry-recovery",
  "etc-card-vs-obu-number-guide",
  "etc-meisai-unknown-entry-ic",
  "etc-meisai-update-timing",
  "etc-meisai-vs-jtr-comparison",
  "etc-meisai-daily-email-howto",
  "etc-meisai-keihi-seisan-tsukaeru-ka",
  "houjin-etc-monthly-organization-howto",
  "kojin-jigyounushi-etc-organization-howto",
  "kakuteishinkoku-mae-etc-check-howto",
  "etc-syanai-seisan-mistake-reduction-howto",
  "etc-pdf-csv-both-storage-reasons",
  "etc-tsukimatsu-checklist-guide",
  "etc-card-betsu-organization-howto",
  "sharyou-betsu-etc-record-howto",
  "bushou-betsu-etc-organization-howto",
  "etc-warikibi-heiyou-junjo-guide",
  "etc-mileage-service-registration-howto",
  "etc-mileage-points-check-howto",
  "etc-warikibi-meisai-hannei-timing",
  "tsuukin-pass-shakai-jikken-etc-warikibi-guide",
  "etc-2-warikibi-taishou-douro-guide",
  "etc-shuyu-pass-meisai-howto",
  "shougaisha-warikibi-etc-meisai-guide",
  "oguchi-tahindo-warikibi-houjin-etc-kanri",
  "etc-warikibi-card-vehicle-betsu-check-howto",
  "hanshin-expressway-etc-meisai-guide",
  "honshu-shikoku-bridge-etc-meisai-guide",
  "tomei-expressway-etc-meisai-guide",
  "kyushu-expressway-etc-meisai-guide",
  "tohoku-expressway-etc-meisai-guide",
  "kan-etsu-expressway-etc-meisai-guide",
  "chuo-expressway-etc-meisai-guide",
  "meishin-expressway-etc-meisai-guide",
  "sanyo-expressway-etc-meisai-guide",
  "hokuriku-expressway-etc-meisai-guide",
  "etc2-large-truck-tolls-discount-guide",
  "medium-vehicle-etc-tolls-meisai-guide",
  "kei-vehicle-vs-standard-etc-tolls-guide",
  "towing-trailer-etc-classification-guide",
  "rental-car-etc-reimbursement-guide",
  "motorcycle-etc-tolls-meisai-guide",
  "heavy-special-vehicle-etc-tolls-guide",
  "public-vehicle-etc-records-management",
  "company-vehicle-etc-meisai-management",
  "ev-truck-commercial-ev-etc-records",
  "etc-obu-new-security-spec-check-guide",
  "etc-setup-shoumeisho-howto-guide",
  "chuko-sha-etc-setup-confirm-howto",
  "number-plate-change-etc-setup-confirm",
  "sharyou-irekae-etc-card-obu-check-howto",
  "etc-card-other-vehicle-meisai-guide",
  "etc-card-expiry-renewal-meisai-check",
  "etc-card-not-inserted-trip-recovery",
  "etc-obu-error-after-meisai-check",
  "etc-registration-mismatch-trip-records",
  "etc-riyou-shoukai-jidoka-guide",
  "etc-riyou-meisai-mail-jido-haishin-guide"
];
